<template>
    <div class="CollapsePanel">
        <div class="head-wrapper" @click="isActive = !isActive">
            <i
                class="el-collapse-item__arrow el-icon-arrow-right"
                :class="{ 'is-active': isActive }"
            ></i>
            <div class="title"><slot name="title"></slot></div>
        </div>
        <div v-show="isActive" class="content-wrapper"><slot></slot></div>
    </div>
</template>

<script>
export default {
    name: "CollapsePanel",
    data() {
        return {
            isActive: true
        };
    }
};
</script>

<style lang="scss" scoped>
.CollapsePanel {
    .head-wrapper {
        user-select: none;
        display: inline-block;
        cursor: pointer;
        .title {
            display: inline-block;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/CollapsePanel/index.vue